import { HStack, Flex } from "@chakra-ui/react";
import { SelectComponent } from "@/components/select/Select";
import { SelectOption } from "../schema/handler-functions";
import { Control, FieldValues } from "react-hook-form";

interface Props {
  yearOptions: SelectOption[];
  moduleTypeOptions: SelectOption[];
  truckOptions: SelectOption[];
  control: Control<FieldValues>;
  loadingModuleTypes: boolean;
  loadingTrucks: boolean;
}

export const SearchSelectorForm = ({
  yearOptions,
  moduleTypeOptions,
  truckOptions,
  control,
  loadingModuleTypes,
  loadingTrucks,
}: Props) => {
  return (
    <HStack paddingTop="12px" gap="16px" alignItems="flex-start">
      <Flex width="200px">
        <SelectComponent
          items={yearOptions}
          control={control}
          name="year"
          labelText="Año"
          placeholder="Seleccionar"
          clearable={false}
        />
      </Flex>

      <Flex width="200px">
        <SelectComponent
          items={moduleTypeOptions}
          control={control}
          name="idTipoModulo"
          labelText="Tipo de módulo"
          placeholder="Seleccionar"
          loading={loadingModuleTypes}
          disabled={loadingModuleTypes}
        />
      </Flex>
      <Flex width="200px">
        <SelectComponent
          items={truckOptions}
          control={control}
          name="idEquipo"
          labelText="Camión"
          placeholder="Seleccionar"
          loading={loadingTrucks}
          disabled={loadingTrucks}
        />
      </Flex>
    </HStack>
  );
};
